import VideoData from './VideoData'

class VideoList {

    initialized = false;

    constructor(result) {

        this.videoList = {};

        if (result) {
            for (let categoryId in result) {
                this.videoList[categoryId] = [];

                for (let ix = 0; ix < result[categoryId].length; ix++) {
                    let v = new VideoData(result[categoryId][ix]);

                    this.videoList[categoryId].push(v);
                }
            }

            this.initialized = true;
        }

    }

    getVideoList() {

        return this.videoList();

    }

    getVideoDataById(video_id) {

        for (let ix in this.videoList) {
            let v = this.videoList[ix];

            if (+(v.video_id) === +(video_id)) return v;
        }

        return [];

    }

}

export default VideoList;